export const DUPLICATED_EMAIL_MESSAGE =
  'すでに登録されているメールアドレスです';

export const AC_EMAIL_INVALID_DOMAIN_MESSAGE =
  'ご所属の大学のメールアドレスは外資就活ドットコムに対応していない可能性があります。';
